<mwe-loading-spinner-extended />
